/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoFusionModelsCustomProductView,
    MelcoFusionModelsCustomProductViewFromJSON,
    MelcoFusionModelsCustomProductViewFromJSONTyped,
    MelcoFusionModelsCustomProductViewToJSON,
    MelcoFusionModelsUserBlank,
    MelcoFusionModelsUserBlankFromJSON,
    MelcoFusionModelsUserBlankFromJSONTyped,
    MelcoFusionModelsUserBlankToJSON,
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsPreview,
    MelcoModelsPreviewFromJSON,
    MelcoModelsPreviewFromJSONTyped,
    MelcoModelsPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoFusionModelsCustomProduct
 */
export interface MelcoFusionModelsCustomProduct {
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCustomProduct
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCustomProduct
     */
    token?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCustomProduct
     */
    name?: string | null;
    /**
     * 
     * @type {MelcoFusionModelsUserBlank}
     * @memberof MelcoFusionModelsCustomProduct
     */
    blank?: MelcoFusionModelsUserBlank;
    /**
     * 
     * @type {Array<MelcoFusionModelsCustomProductView>}
     * @memberof MelcoFusionModelsCustomProduct
     */
    view_list?: Array<MelcoFusionModelsCustomProductView> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoFusionModelsCustomProduct
     */
    version?: number;
    /**
     * 
     * @type {number}
     * @memberof MelcoFusionModelsCustomProduct
     */
    publish_state?: number;
    /**
     * 
     * @type {Date}
     * @memberof MelcoFusionModelsCustomProduct
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MelcoFusionModelsCustomProduct
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoFusionModelsCustomProduct
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {Array<MelcoModelsPreview>}
     * @memberof MelcoFusionModelsCustomProduct
     */
    default_previews?: Array<MelcoModelsPreview> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoFusionModelsCustomProduct
     */
    configurator_version?: number | null;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoFusionModelsCustomProduct
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
}

export function MelcoFusionModelsCustomProductFromJSON(json: any): MelcoFusionModelsCustomProduct {
    return MelcoFusionModelsCustomProductFromJSONTyped(json, false);
}

export function MelcoFusionModelsCustomProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoFusionModelsCustomProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'token': !exists(json, 'token') ? undefined : json['token'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'blank': !exists(json, 'blank') ? undefined : MelcoFusionModelsUserBlankFromJSON(json['blank']),
        'view_list': !exists(json, 'view_list') ? undefined : (json['view_list'] === null ? null : (json['view_list'] as Array<any>).map(MelcoFusionModelsCustomProductViewFromJSON)),
        'version': !exists(json, 'version') ? undefined : json['version'],
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'default_previews': !exists(json, 'default_previews') ? undefined : (json['default_previews'] === null ? null : (json['default_previews'] as Array<any>).map(MelcoModelsPreviewFromJSON)),
        'configurator_version': !exists(json, 'configurator_version') ? undefined : json['configurator_version'],
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
    };
}

export function MelcoFusionModelsCustomProductToJSON(value?: MelcoFusionModelsCustomProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'token': value.token,
        'name': value.name,
        'blank': MelcoFusionModelsUserBlankToJSON(value.blank),
        'view_list': value.view_list === undefined ? undefined : (value.view_list === null ? null : (value.view_list as Array<any>).map(MelcoFusionModelsCustomProductViewToJSON)),
        'version': value.version,
        'publish_state': value.publish_state,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'default_previews': value.default_previews === undefined ? undefined : (value.default_previews === null ? null : (value.default_previews as Array<any>).map(MelcoModelsPreviewToJSON)),
        'configurator_version': value.configurator_version,
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
    };
}


